// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modal_modal-container__IUqBX {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  position: fixed;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 70px 0;
  z-index: var(--m-z-index-modal-backdrop);
  background: rgba(35, 48, 67, 0.28);
  background-color: var(--m-modal-overlay-background-color);
  overflow: auto;
  color: var(--m-text);
}
.Modal_modal-container__IUqBX .Modal_modal-content__qLwCh {
  background-color: rgb(255, 255, 255);
  border-radius: var(--m-border-radius);
  color: var(--m-text);
  display: flex;
  flex-direction: column;
  outline: 0px;
  pointer-events: auto;
  border: 1px solid transparent;
  z-index: var(--m-z-index-modal);
  background-color: var(--m-card-background-color) !important;
}
.Modal_modal-container__IUqBX .Modal_modal-content--small__e1Opn {
  min-width: 400px;
  width: 400px;
  max-width: 400px;
}
.Modal_modal-container__IUqBX .Modal_modal-content--medium__vdBTJ {
  min-width: 600px;
  width: 600px;
  max-width: 600px;
}
.Modal_modal-container__IUqBX .Modal_modal-content--large__IP66s {
  min-width: 800px;
  width: 800px;
  max-width: 800px;
}
.Modal_modal-container__IUqBX .Modal_modal-content--x-large__tGjoJ {
  min-width: 1040px;
  width: 1040px;
  max-width: 1040px;
}
.Modal_modal-container__IUqBX .Modal_modal-content--scroll-inside__dcrg8 {
  height: auto;
  max-height: 100%;
}
.Modal_modal-container__IUqBX .Modal_modal-content--scroll-inside__dcrg8 .Modal_body__fG81S {
  height: auto;
  overflow: auto;
}
.Modal_modal-container__IUqBX .Modal_modal-content__header__CMlUA {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 0 0 auto;
  z-index: 1;
  padding: 16px 24px;
  box-shadow: none;
}
.Modal_modal-container__IUqBX .Modal_modal-content__header--title__0SWDH {
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  flex: 1 1;
  min-width: 0;
  margin: 0;
}
.Modal_modal-container__IUqBX .Modal_modal-content__header--close__9gxHg {
  padding: 0;
  cursor: pointer;
  position: relative;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  color: var(--m-text-secondary, #6b7280);
  transition: all 0.2s ease-in-out;
  flex-shrink: 0;
  margin-left: 12px;
}
.Modal_modal-container__IUqBX .Modal_modal-content__header--close__9gxHg svg {
  transition: transform 0.2s ease-in-out;
}
.Modal_modal-container__IUqBX .Modal_modal-content__header--close__9gxHg:hover {
  background-color: var(--m-subtle, #f3f4f6);
  color: var(--m-text, #1f2937);
}
.Modal_modal-container__IUqBX .Modal_modal-content__header--close__9gxHg:active {
  transform: scale(0.95);
  background-color: var(--m-subtle-hover, #e5e7eb);
}
.Modal_modal-container__IUqBX .Modal_modal-content__header--close__9gxHg:focus {
  outline: 2px solid var(--m-primary, #00b4f3);
  outline-offset: 2px;
}
.Modal_modal-container__IUqBX .Modal_modal-content__header--close__9gxHg:focus:not(:focus-visible) {
  outline: none;
}
.Modal_modal-container__IUqBX .Modal_modal-content__header--border-bottom__i7x7I {
  border-bottom: 2px solid var(border-color);
}
.Modal_modal-container__IUqBX .Modal_modal-content__qLwCh .Modal_body__fG81S {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  padding: 8px 24px;
  overflow-x: hidden !important;
}
.Modal_modal-container__IUqBX .Modal_modal-content__qLwCh {
  /* Same layout as &__header, placed as first row inside .body (full-bleed vs body padding). */
}
.Modal_modal-container__IUqBX .Modal_modal-content__qLwCh .Modal_modal-body-inline-header__iGGjU {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 0 0 auto;
  z-index: 2;
  padding: 16px 24px;
  margin: -8px -24px 8px;
  box-sizing: border-box;
  width: calc(100% + 48px);
  max-width: calc(100% + 48px);
  box-shadow: none;
}
.Modal_modal-container__IUqBX .Modal_modal-content__qLwCh .Modal_modal-body-close-row__vOIlR {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 0;
  margin: -2px 0 10px;
  position: relative;
  z-index: 2;
}
.Modal_modal-container__IUqBX .Modal_modal-content__qLwCh .Modal_footer-modal__xjTcq {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 16px;
  position: relative;
}
.Modal_modal-container__IUqBX .Modal_modal-content__qLwCh .Modal_footer-modal__buttons__\\+QF9n {
  display: flex;
  align-items: center;
  gap: 10px;
}
.Modal_modal-container__IUqBX .Modal_modal-content__qLwCh .Modal_footer-modal--border-top__8x\\+uD {
  border-top: 2px solid var(--m-border-color);
}
@media (max-width: 480px) {
  .Modal_modal-container__IUqBX .Modal_modal-content--small__e1Opn {
    min-width: 360px;
    width: 360px;
    max-width: 360px;
  }
  .Modal_modal-container__IUqBX .Modal_modal-content--medium__vdBTJ {
    min-width: 360px;
    width: 360px;
    max-width: 360px;
  }
  .Modal_modal-container__IUqBX .Modal_modal-content--large__IP66s {
    min-width: 360px;
    width: 360px;
    max-width: 360px;
  }
  .Modal_modal-container__IUqBX .Modal_modal-content--x-large__tGjoJ {
    min-width: 360px;
    width: 360px;
    max-width: 360px;
  }
}
@media (min-width: 481px) and (max-width: 768px) {
  .Modal_modal-container__IUqBX .Modal_modal-content--small__e1Opn {
    min-width: 500px;
    width: 500px;
    max-width: 500px;
  }
  .Modal_modal-container__IUqBX .Modal_modal-content--medium__vdBTJ {
    min-width: 600px;
    width: 600px;
    max-width: 600px;
  }
  .Modal_modal-container__IUqBX .Modal_modal-content--large__IP66s {
    min-width: 700px;
    width: 700px;
    max-width: 700px;
  }
  .Modal_modal-container__IUqBX .Modal_modal-content--x-large__tGjoJ {
    min-width: 800px;
    width: 800px;
    max-width: 800px;
  }
}

[m-data-theme=dark] .Modal_modal-container__IUqBX .Modal_modal-content__header--close__9gxHg {
  color: var(--m-text-secondary, #9ca3af);
}
[m-data-theme=dark] .Modal_modal-container__IUqBX .Modal_modal-content__header--close__9gxHg:hover {
  background-color: var(--m-subtle-card-background-color, rgba(255, 255, 255, 0.1));
  color: var(--m-text, #ffffff);
}
[m-data-theme=dark] .Modal_modal-container__IUqBX .Modal_modal-content__header--close__9gxHg:active {
  background-color: var(--m-subtle-hover, rgba(255, 255, 255, 0.15));
}`, "",{"version":3,"sources":["webpack://./src/components/BaseUI/Modal/Modal.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;EACA,wCAAA;EACA,kCAAA;EACA,yDAAA;EACA,cAAA;EACA,oBAAA;AACF;AACE;EACE,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,oBAAA;EACA,6BAAA;EACA,+BAAA;EACA,2DAAA;AACJ;AACI;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;AACN;AAEI;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;AAAN;AAGI;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;AADN;AAII;EACE,iBAAA;EACA,aAAA;EACA,iBAAA;AAFN;AAKI;EACE,YAAA;EACA,gBAAA;AAHN;AAKM;EACE,YAAA;EACA,cAAA;AAHR;AAOI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;AALN;AAOM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;EACA,YAAA;EACA,SAAA;AALR;AAQM;EACE,UAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,uCAAA;EACA,gCAAA;EACA,cAAA;EACA,iBAAA;AANR;AAQQ;EACE,sCAAA;AANV;AASQ;EACE,0CAAA;EACA,6BAAA;AAPV;AAUQ;EACE,sBAAA;EACA,gDAAA;AARV;AAWQ;EACE,4CAAA;EACA,mBAAA;AATV;AAYQ;EACE,aAAA;AAVV;AAcM;EACE,0CAAA;AAZR;AAgBI;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,iBAAA;EACA,6BAAA;AAdN;AArGE;EAsHE,6FAAA;AAdJ;AAeI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,wBAAA;EACA,4BAAA;EACA,gBAAA;AAbN;AAgBI;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AAdN;AAiBI;EACE,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;AAfN;AAiBM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAfR;AAkBM;EACE,2CAAA;AAhBR;AAoBI;EACE;IACE,gBAAA;IACA,YAAA;IACA,gBAAA;EAlBN;EAqBI;IACE,gBAAA;IACA,YAAA;IACA,gBAAA;EAnBN;EAsBI;IACE,gBAAA;IACA,YAAA;IACA,gBAAA;EApBN;EAuBI;IACE,gBAAA;IACA,YAAA;IACA,gBAAA;EArBN;AACF;AAwBI;EACE;IACE,gBAAA;IACA,YAAA;IACA,gBAAA;EAtBN;EAyBI;IACE,gBAAA;IACA,YAAA;IACA,gBAAA;EAvBN;EA0BI;IACE,gBAAA;IACA,YAAA;IACA,gBAAA;EAxBN;EA2BI;IACE,gBAAA;IACA,YAAA;IACA,gBAAA;EAzBN;AACF;;AAkCQ;EACE,uCAAA;AA/BV;AAiCU;EACE,iFAAA;EAIA,6BAAA;AAlCZ;AAqCU;EACE,kEAAA;AAnCZ","sourcesContent":[".modal-container {\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  position: fixed;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 70px 0;\n  z-index: var(--m-z-index-modal-backdrop);\n  background: rgba(35, 48, 67, 0.28);\n  background-color: var(--m-modal-overlay-background-color);\n  overflow: auto;\n  color: var(--m-text);\n\n  .modal-content {\n    background-color: rgb(255, 255, 255);\n    border-radius: var(--m-border-radius);\n    color: var(--m-text);\n    display: flex;\n    flex-direction: column;\n    outline: 0px;\n    pointer-events: auto;\n    border: 1px solid transparent;\n    z-index: var(--m-z-index-modal);\n    background-color: var(--m-card-background-color) !important;\n\n    &--small {\n      min-width: 400px;\n      width: 400px;\n      max-width: 400px;\n    }\n\n    &--medium {\n      min-width: 600px;\n      width: 600px;\n      max-width: 600px;\n    }\n\n    &--large {\n      min-width: 800px;\n      width: 800px;\n      max-width: 800px;\n    }\n\n    &--x-large {\n      min-width: 1040px;\n      width: 1040px;\n      max-width: 1040px;\n    }\n\n    &--scroll-inside {\n      height: auto;\n      max-height: 100%;\n\n      .body {\n        height: auto;\n        overflow: auto;\n      }\n    }\n\n    &__header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      flex: 0 0 auto;\n      z-index: 1;\n      padding: 16px 24px;\n      box-shadow: none;\n\n      &--title {\n        font-weight: 500;\n        font-size: 18px;\n        line-height: 20px;\n        flex: 1;\n        min-width: 0;\n        margin: 0;\n      }\n\n      &--close {\n        padding: 0;\n        cursor: pointer;\n        position: relative;\n        width: 32px;\n        height: 32px;\n        border-radius: 8px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border: none;\n        background: transparent;\n        color: var(--m-text-secondary, #6b7280);\n        transition: all 0.2s ease-in-out;\n        flex-shrink: 0;\n        margin-left: 12px;\n\n        svg {\n          transition: transform 0.2s ease-in-out;\n        }\n\n        &:hover {\n          background-color: var(--m-subtle, #f3f4f6);\n          color: var(--m-text, #1f2937);\n        }\n\n        &:active {\n          transform: scale(0.95);\n          background-color: var(--m-subtle-hover, #e5e7eb);\n        }\n\n        &:focus {\n          outline: 2px solid var(--m-primary, #00b4f3);\n          outline-offset: 2px;\n        }\n\n        &:focus:not(:focus-visible) {\n          outline: none;\n        }\n      }\n\n      &--border-bottom {\n        border-bottom: 2px solid var(border-color);\n      }\n    }\n\n    .body {\n      display: flex;\n      flex: 1 1 auto;\n      flex-direction: column;\n      padding: 8px 24px;\n      overflow-x: hidden !important;\n    }\n\n    /* Same layout as &__header, placed as first row inside .body (full-bleed vs body padding). */\n    .modal-body-inline-header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      flex: 0 0 auto;\n      z-index: 2;\n      padding: 16px 24px;\n      margin: -8px -24px 8px;\n      box-sizing: border-box;\n      width: calc(100% + 48px);\n      max-width: calc(100% + 48px);\n      box-shadow: none;\n    }\n\n    .modal-body-close-row {\n      display: flex;\n      justify-content: flex-end;\n      align-items: center;\n      flex-shrink: 0;\n      margin: -2px 0 10px;\n      position: relative;\n      z-index: 2;\n    }\n\n    .footer-modal {\n      display: flex;\n      align-items: flex-end;\n      justify-content: flex-end;\n      padding: 16px;\n      position: relative;\n\n      &__buttons {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n      }\n\n      &--border-top {\n        border-top: 2px solid var(--m-border-color);\n      }\n    }\n\n    @media (max-width: 480px) {\n      &--small {\n        min-width: 360px;\n        width: 360px;\n        max-width: 360px;\n      }\n\n      &--medium {\n        min-width: 360px;\n        width: 360px;\n        max-width: 360px;\n      }\n\n      &--large {\n        min-width: 360px;\n        width: 360px;\n        max-width: 360px;\n      }\n\n      &--x-large {\n        min-width: 360px;\n        width: 360px;\n        max-width: 360px;\n      }\n    }\n\n    @media (min-width: 481px) and (max-width: 768px) {\n      &--small {\n        min-width: 500px;\n        width: 500px;\n        max-width: 500px;\n      }\n\n      &--medium {\n        min-width: 600px;\n        width: 600px;\n        max-width: 600px;\n      }\n\n      &--large {\n        min-width: 700px;\n        width: 700px;\n        max-width: 700px;\n      }\n\n      &--x-large {\n        min-width: 800px;\n        width: 800px;\n        max-width: 800px;\n      }\n    }\n  }\n}\n\n[m-data-theme=\"dark\"] {\n  .modal-container {\n    .modal-content {\n      &__header {\n        &--close {\n          color: var(--m-text-secondary, #9ca3af);\n\n          &:hover {\n            background-color: var(\n              --m-subtle-card-background-color,\n              rgba(255, 255, 255, 0.1)\n            );\n            color: var(--m-text, #ffffff);\n          }\n\n          &:active {\n            background-color: var(--m-subtle-hover, rgba(255, 255, 255, 0.15));\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-container": `Modal_modal-container__IUqBX`,
	"modal-content": `Modal_modal-content__qLwCh`,
	"modal-content--small": `Modal_modal-content--small__e1Opn`,
	"modal-content--medium": `Modal_modal-content--medium__vdBTJ`,
	"modal-content--large": `Modal_modal-content--large__IP66s`,
	"modal-content--x-large": `Modal_modal-content--x-large__tGjoJ`,
	"modal-content--scroll-inside": `Modal_modal-content--scroll-inside__dcrg8`,
	"body": `Modal_body__fG81S`,
	"modal-content__header": `Modal_modal-content__header__CMlUA`,
	"modal-content__header--title": `Modal_modal-content__header--title__0SWDH`,
	"modal-content__header--close": `Modal_modal-content__header--close__9gxHg`,
	"modal-content__header--border-bottom": `Modal_modal-content__header--border-bottom__i7x7I`,
	"modal-body-inline-header": `Modal_modal-body-inline-header__iGGjU`,
	"modal-body-close-row": `Modal_modal-body-close-row__vOIlR`,
	"footer-modal": `Modal_footer-modal__xjTcq`,
	"footer-modal__buttons": `Modal_footer-modal__buttons__+QF9n`,
	"footer-modal--border-top": `Modal_footer-modal--border-top__8x+uD`
};
export default ___CSS_LOADER_EXPORT___;
